const sleep = (n: number): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve()
    }, n)
  })

export default sleep
